import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SvgIcon from './SvgIcon';

const FlagIcon = ({ flagCode, className }) => {
    return (
        <SvgIcon
            className={classNames('FlagIcon', className)}
            path="images/flags"
            icon={flagCode}
        />
    )
};

FlagIcon.propTypes = {
    flagCode: PropTypes.string.isRequired,
    className: PropTypes.string,
};

export default FlagIcon;
